import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Configuration de Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const AdminDashboard = () => {
  const [products, setProducts] = useState([]);
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    axios.get('http://localhost:5000/api/products/products') // Remplacez par votre URL d'API
      .then((response) => {
        if (response.data && response.data.products) {
          setProducts(response.data.products);

          // Préparer les données pour le graphique
          const labels = response.data.products.map((product) => product.name); // Noms des produits
          const prices = response.data.products.map((product) => Number(product.price)); // Prix des produits

          setChartData({
            labels: labels,
            datasets: [
              {
                label: 'Prix des produits',
                data: prices,
                backgroundColor: 'rgba(75, 192, 192, 0.5)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
              },
            ],
          });
        } else {
          console.error('Données mal formatées:', response.data);
        }
      })
      .catch((error) => {
        console.error('Erreur lors de la récupération des produits:', error);
      });
  }, []);

  return (
    <div>
      <h1>Admin Dashboard</h1>
      {/* Affichage du graphique */}
      {chartData.labels ? (
        <Bar
          data={chartData}
          options={{
            responsive: true,
            plugins: {
              legend: {
                position: 'top',
              },
              title: {
                display: true,
                text: 'Prix des produits',
              },
            },
          }}
        />
      ) : (
        <p>Chargement des données du graphique...</p>
      )}
    </div>
  );
};

export default AdminDashboard;
